import React from 'react';
import CreateApkState from './createApkState/createApkState';
import Form from './components/Form/Form';
import { ModalWindows } from './components/ModalWindows';

const CreateApkPage: React.FC = () => {
	return (
		<CreateApkState>
			<Form />
			<ModalWindows />
		</CreateApkState>
	);
};

export default CreateApkPage;
